import React from 'react';
import { Box, ClickToCopy, Inscription } from '@common-fe/common-fe';

interface Props {
  accountNumber?: string;
  accountPlaceholder?: string;
  routingNumber?: string;
  testId?: string;
}

export const AccountToPushToField: React.FC<Props> = ({
  accountNumber,
  accountPlaceholder,
  routingNumber,
  testId,
}) => {
  return (
    <Box width={{ max: '500px' }} direction="row" gap="spacing4">
      {accountNumber ? (
        <Box direction="row" gap="spacing4">
          <Box direction="row" gap="spacing4">
            <Inscription>
              A:
            </Inscription>
            <ClickToCopy
              isIconVisible
              title={accountNumber}
              testId={`${testId}-${accountNumber}`}
            />
          </Box>
          <Inscription color='textDisabled'>
            /
          </Inscription>
          <Box direction="row" gap="spacing4">
            <Inscription>
              R:
            </Inscription>
            <ClickToCopy
              isIconVisible
              title={routingNumber || ''}
              testId={`${testId}-${routingNumber}`}
            />
          </Box>
        </Box>
      ) : (
        <Inscription
          color="textBody"
          data-testid="accountToPushToA-placeholder"
        >
          {accountPlaceholder}
        </Inscription>
      )}
    </Box>
  );
};
